
import {useHistory} from "react-router-dom";
export const usePageChange = () => {
    const history = useHistory();
    const goToPage = (path) => {
        history.push(path);
    };
    return {goToPage};
};